import { useCallback, useState } from 'react';

export default function useBooleanState(initialValue = false): [boolean, () => void, () => void, () => void] {
  const [value, setValue] = useState(initialValue);

  const toggle = useCallback(() => {
    setValue((prevValue) => !prevValue);
  }, []);

  const setToTrue = useCallback(() => {
    setValue(true);
  }, []);

  const setToFalse = useCallback(() => {
    setValue(false);
  }, []);

  return [value, toggle, setToTrue, setToFalse];
}
